/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface BeamAnalysisCorrectionsDto
 */
export interface BeamAnalysisCorrectionsDto {
    /**
     * 
     * @type {number}
     * @memberof BeamAnalysisCorrectionsDto
     */
    airTemperature?: number;
    /**
     * 
     * @type {boolean}
     * @memberof BeamAnalysisCorrectionsDto
     */
    adjustAirTemperature?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BeamAnalysisCorrectionsDto
     */
    airPressure?: number;
    /**
     * 
     * @type {boolean}
     * @memberof BeamAnalysisCorrectionsDto
     */
    adjustAirPressure?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BeamAnalysisCorrectionsDto
     */
    referenceTemperature?: number;
    /**
     * 
     * @type {boolean}
     * @memberof BeamAnalysisCorrectionsDto
     */
    adjustReferenceTemperature?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BeamAnalysisCorrectionsDto
     */
    referencePressure?: number;
    /**
     * 
     * @type {number}
     * @memberof BeamAnalysisCorrectionsDto
     */
    correctionFactor?: number;
    /**
     * 
     * @type {boolean}
     * @memberof BeamAnalysisCorrectionsDto
     */
    adjustCorrectionFactor?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BeamAnalysisCorrectionsDto
     */
    $type?: BeamAnalysisCorrectionsDtoTypeEnum;
}


/**
 * @export
 */
export const BeamAnalysisCorrectionsDtoTypeEnum = {
    PtwPtw100BeamAnalysisApplicationTaskItemComponentDtoBeamAnalysisCorrectionsDtoPtwPtw100BeamAnalysisApplication: 'Ptw.Ptw100.BeamAnalysis.Application.TaskItemComponent.Dto.BeamAnalysisCorrectionsDto, Ptw.Ptw100.BeamAnalysis.Application'
} as const;
export type BeamAnalysisCorrectionsDtoTypeEnum = typeof BeamAnalysisCorrectionsDtoTypeEnum[keyof typeof BeamAnalysisCorrectionsDtoTypeEnum];



/**
 * Check if a given object implements the BeamAnalysisCorrectionsDto interface.
 */
export function instanceOfBeamAnalysisCorrectionsDto(value?: unknown): value is BeamAnalysisCorrectionsDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(BeamAnalysisCorrectionsDtoTypeEnum)[0];
}

export function BeamAnalysisCorrectionsDtoFromJSON(json: any): BeamAnalysisCorrectionsDto {
    return BeamAnalysisCorrectionsDtoFromJSONTyped(json, false);
}

export function BeamAnalysisCorrectionsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BeamAnalysisCorrectionsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'airTemperature': json['airTemperature'] == null ? undefined : json['airTemperature'],
        'adjustAirTemperature': json['adjustAirTemperature'] == null ? undefined : json['adjustAirTemperature'],
        'airPressure': json['airPressure'] == null ? undefined : json['airPressure'],
        'adjustAirPressure': json['adjustAirPressure'] == null ? undefined : json['adjustAirPressure'],
        'referenceTemperature': json['referenceTemperature'] == null ? undefined : json['referenceTemperature'],
        'adjustReferenceTemperature': json['adjustReferenceTemperature'] == null ? undefined : json['adjustReferenceTemperature'],
        'referencePressure': json['referencePressure'] == null ? undefined : json['referencePressure'],
        'correctionFactor': json['correctionFactor'] == null ? undefined : json['correctionFactor'],
        'adjustCorrectionFactor': json['adjustCorrectionFactor'] == null ? undefined : json['adjustCorrectionFactor'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function BeamAnalysisCorrectionsDtoToJSON(value?: BeamAnalysisCorrectionsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'airTemperature': value['airTemperature'],
        'adjustAirTemperature': value['adjustAirTemperature'],
        'airPressure': value['airPressure'],
        'adjustAirPressure': value['adjustAirPressure'],
        'referenceTemperature': value['referenceTemperature'],
        'adjustReferenceTemperature': value['adjustReferenceTemperature'],
        'referencePressure': value['referencePressure'],
        'correctionFactor': value['correctionFactor'],
        'adjustCorrectionFactor': value['adjustCorrectionFactor'],
        '$type': value['$type'],
    });
}

